import type { TestPodRunData } from '@/shared/types/workspace';

export type TestPodLine = {
  key: string;
  label: string;
  text: string;
  detail: string;
  isError: boolean;
};

/** What the dark log block shows for a run. The orchestrator does not stream lines yet. */
export function testPodLines(run: TestPodRunData | null): TestPodLine[] {
  if (!run) return [];
  if (run.status === 'QUEUED' || run.status === 'RUNNING') {
    return [
      {
        key: 'boot',
        label: 'boot',
        text: 'macOS Pod from the warm pool',
        detail: 'starting',
        isError: false,
      },
    ];
  }
  if (run.status === 'FAILED') {
    return [
      {
        key: 'fail',
        label: 'build',
        text: `sample app failed, code ${run.reference}`,
        detail: 'failed',
        isError: true,
      },
    ];
  }
  if (run.status === 'PASSED') {
    return [
      {
        key: 'shot',
        label: 'shot',
        text: 'screenshot attached, Pod stops in 10 min',
        detail: 'done',
        isError: false,
      },
    ];
  }
  return [];
}
